import { useCallback } from "react";
import EstateMpProvider from "@/core/data-provider/data-mp/estate/estate-mp-provider.ts";
import useAppDispatch from "@/core/helpers/useAppDispatch";
import useAppSelector from "@/core/helpers/useAppSelector";
import { RpcMpProviderSuccessResponse } from "@/core/rpc-mp-provider/responses/rpc-mp-provider-success-response";
import { IS_DEV } from "@/domains/main/constants/other";
import { estateSelector, setTenants } from "@/domains/estate/slice";
import { fakeResidents } from "@/domains/estate/helpers/fakeData";

export default () => {
  const dispatch = useAppDispatch();
  const estate = useAppSelector(estateSelector);

  const loadTenants = useCallback(async () => {
    if (IS_DEV) {
      dispatch(setTenants(fakeResidents));
    } else {
      try {
        if (estate) {
          const response = await EstateMpProvider.getTenants(estate.id);
          if (response instanceof RpcMpProviderSuccessResponse) {
            dispatch(
              setTenants(
                response.data.tenants.map((tenant) =>
                  tenant
                    ? {
                        name: tenant.name,
                        characterId: tenant.characterId,
                        playerMpId: tenant.playerMpId,
                        permissions: {
                          wardrobe: tenant.wardrobe,
                          fridge: tenant.fridge,
                          garage: tenant.garage,
                          upgrade: tenant.upgrade,
                          safe: tenant.safe,
                        },
                        fee: tenant.feeAmount,
                        paidFee: tenant.paidFee,
                      }
                    : null,
                ),
              ),
            );
          } else {
            // TODO: уводемить об ошибке
            console.log("set tenants:", response);
          }
        }
      } catch (e) {
        console.log(e);
      }
    }
  }, [dispatch, estate?.id]);

  return {
    loadTenants,
  };
};
